<template>
  <v-layout
    text-center
    wrap
  >
    <v-flex
      v-for="(item, index) in items"
      :key="`commercial${index}`"
      v-bind="{ [`xs${!isSimulation && isDesktop ? 4 : 12}`]: true }"
    >
      <commercial
        :data="item"
      />
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import axios from 'axios'
  import api from '@/services/api'
  import constants from '@/constants'
  import Commercial from './Commercial'
  export default {
    components: {
      Commercial
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null,
      },
      menuID: {
        type: String,
        required: false,
        default: null
      }
    },
    data: () => ({
      DviewLinkParrilla: null,
      ShowMoscaDFeel: false,
      items: null,
      numItem: 0,
      active: 0 
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'BGColorContent', 'BGColor', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile();
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
      expandMenuID () {
        return this.$store.state.app.expandMenuID
      }
    },
    mounted () {
      this.getEnterprise()
    },
    methods: {
      getEnterprise () {
        api.getItem('enterprises', false, this.$store.state.app.enterpriseID).then(response => {
          this.DviewLinkCommercial = response.DviewLinkCommercial
          this.ShowMoscaDFeel = response.ShowMoscaDFeel

          this.handleGetCommercial()
        })
      },
      handleGetCommercial () {    
        this.activities = axios.get(`https://www.dviewcontent.com/api/p_event/${this.DviewLinkCommercial}?showAll=true`,)
          .then(response => {
            this.items = response.data && response.data ? response.data : []
          })
      },
    }
  }
</script>
<style scoped>
  .activity .container {
    padding: 0px;
  }
  .layout.activity.justify-center {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .activity .v-toolbar__content {
    padding: 0px !important;
    margin: auto !important;
  }
  .activity-button {
    margin-left: 10px;
  }
  .activity-button:hover {
    opacity: 0.7;
  }
  .td:hover {
    cursor: pointer;
  }
</style>
